import { ShoppingBag, DollarSign, Users } from "lucide-react";
import { formatPrice } from "@/lib/formatPrice";

interface DashboardKpiCardsProps {
  orders: number;
  revenue: number;
  avgOrderValue: number;
  totalCustomers: number;
}

export default function DashboardKpiCards({ orders, revenue, avgOrderValue, totalCustomers }: DashboardKpiCardsProps) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
      <div className="bg-white rounded-xl border border-border/60 p-4 sm:p-5">
        <div className="size-9 rounded-lg bg-blue-50 flex items-center justify-center">
          <ShoppingBag className="size-4 text-blue-600" />
        </div>
        <p className="text-[11px] uppercase tracking-wider text-muted-foreground font-medium mt-3">Narudžbe</p>
        <p className="text-2xl sm:text-3xl font-semibold tabular-nums mt-1">{orders}</p>
      </div>

      <div className="bg-white rounded-xl border border-border/60 p-4 sm:p-5">
        <div className="size-9 rounded-lg bg-emerald-50 flex items-center justify-center">
          <DollarSign className="size-4 text-emerald-600" />
        </div>
        <p className="text-[11px] uppercase tracking-wider text-muted-foreground font-medium mt-3">Prihod</p>
        <p className="text-2xl sm:text-3xl font-semibold tabular-nums mt-1">{formatPrice(revenue)} KM</p>
      </div>

      <div className="bg-white rounded-xl border border-border/60 p-4 sm:p-5">
        <div className="size-9 rounded-lg bg-amber-50 flex items-center justify-center">
          <ShoppingBag className="size-4 text-amber-600" />
        </div>
        <p className="text-[11px] uppercase tracking-wider text-muted-foreground font-medium mt-3">Prosj. narudžba</p>
        <p className="text-2xl sm:text-3xl font-semibold tabular-nums mt-1">{formatPrice(avgOrderValue)} KM</p>
      </div>

      <div className="bg-white rounded-xl border border-border/60 p-4 sm:p-5">
        <div className="size-9 rounded-lg bg-purple-50 flex items-center justify-center">
          <Users className="size-4 text-purple-600" />
        </div>
        <p className="text-[11px] uppercase tracking-wider text-muted-foreground font-medium mt-3">Kupci</p>
        <p className="text-2xl sm:text-3xl font-semibold tabular-nums mt-1">{totalCustomers}</p>
      </div>
    </div>
  );
}
